import { createDownloadableLink } from '@/helpers';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({
    data,
  }),
  getData:
    (search, paging, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().caConsult.paging;
      let { result, status } = await Api.post(`consultations/search`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...filterOption,
      });
      if (status === 200) {
        caConsultDispatcher.getDataSuccess(result);
      }
    },
  confirmPayment:
    (id, search, filterOption = {}) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/confirm-payment`);
      if (status === 200) {
        let pagingData = getState().caConsult.paging;
        caConsultDispatcher.getData(search, pagingData, filterOption);
      }
    },
  processSummary:
    (id, search, filterOption = {}) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/summary`);
      if (status === 200) {
        let pagingData = getState().caConsult.paging;
        caConsultDispatcher.getData(search, pagingData, filterOption);
      }
    },
  confirmOtp:
    (id, otp, callback) =>
    async ({ Api, getState }) => {
      let { status, message } = await Api.put(
        `calls/${id}/otp-confirmation`,
        otp,
        null,
        null,
        false
      );
      callback({ message, status });
    },
  updateDeliveryStatus:
    (id, data = {}, callback) =>
    async ({ Api }) => {
      let { status } = await Api.put(
        `medicine-deliveries/${id}/delivery-info`,
        data
      );
      status === 200 && callback();
    },
  doneConsult:
    (id, search, filterOption = {}) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/make-done`);
      if (status === 200) {
        let pagingData = getState().caConsult.paging;
        caConsultDispatcher.getData(search, pagingData, filterOption);
      }
    },
  updateDeliveryType:
    (id, deliveryType, callback) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(
        `medicine-deliveries/${id}/request-delivery`,
        {
          deliveryType,
        }
      );
      status === 200 && callback(result);
    },
  forceCancelConsult:
    (id, search, filterOption = {}) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/force-cancellation`);
      if (status === 200) {
        let pagingData = getState().caConsult.paging;
        caConsultDispatcher.getData(search, pagingData, filterOption);
      }
    },
  editConsultPrescription:
    (id, payload, callback) =>
    async ({ Api }) => {
      let { status } = await Api.put(`calls/${id}/edit-price`, payload);
      if (status === 200) {
        callback();
      }
    },
  confirmReadyToPay:
    (id, search, filterOption = {}) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/price-confirmation`);
      if (status === 200) {
        let pagingData = getState().caConsult.paging;
        caConsultDispatcher.getData(search, pagingData, filterOption);
      }
    },
  updateStatusPayment:
    ({ id, search, filterOption = {}, data, onDone, onSuccess }) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/pay-in-cash`, data);
      if (status === 200) {
        let { paging } = getState().caConsult;
        onSuccess();
        caConsultDispatcher.getData(search, paging, filterOption);
      }
      onDone();
    },
  getExportExcel:
    (search, filterOption = {}) =>
    async ({ Api }) => {
      let { result, status } = await Api.post(`consultations/exports/csv`, {
        search,
        ...filterOption,
      });
      status === 200 && createDownloadableLink(result);
    },
  revertStatusToResultCompleted:
    ({ id, onSuccess, search, filterOption = {} }) =>
    async ({ Api, getState }) => {
      const { status } = await Api.put(`calls/${id}/reverse`);
      if (status === 200) {
        const { paging } = getState().caConsult;
        caConsultDispatcher.getData(search, paging, filterOption);
        onSuccess();
      }
    },
  revertCoPayment:
    ({ id, onSuccess, search, filterOption = {} }) =>
    async ({ Api, getState }) => {
      const { status } = await Api.delete(`calls/${id}/co-payment`);
      if (status === 200) {
        const { paging } = getState().caConsult;
        caConsultDispatcher.getData(search, paging, filterOption);
        onSuccess();
      }
    },
  getConsultDetail:
    (id, onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.get(`consultations/${id}`);
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },
  updateCoPayment:
    ({ id, search, filterOption = {}, data, onSuccess }) =>
    async ({ Api, getState }) => {
      let { status } = await Api.put(`calls/${id}/co-payment`, data);
      caConsultDispatcher.setState('loading', false);
      if (status === 200) {
        let { paging } = getState().caConsult;
        onSuccess();
        caConsultDispatcher.getData(search, paging, filterOption);
      }
    },

  setState: (state, value) => ({ state, value }),
};

const caConsultDispatcher = synthesize('caConsult', mapDispatchToAC);
export default caConsultDispatcher;
